import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// import Navbar from "./components/Navbar/Navbar";
// import Footer from "./components/Footer/Footer";

import Home from "./components/pages/Home";
import OurService from "./components/pages/OurService";
import Reservation from "./components/pages/Reservation";
import Contact from "./components/pages/Contact";

function App() {
  return (
    <Router>
      {/* NAVBAR */}
      {/* <Navbar /> */}

      {/* PAGE ROUTES */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<OurService />} />
        <Route path="/reservation" element={<Reservation />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>

      {/* FOOTER (always visible) */}
      {/* <Footer /> */}
    </Router>
  );
}

export default App;